module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"filters":"Filters","quote":"Update your quote","search":"Update your search"}}')
  delete Component.options._Ctor
}
